<div class="accordion-container">
    <div class="header-section">
      <h4>{{'INTRO_WIZARD_TITLE_TEXT' | translate}}</h4>
      <button class="close-button" (click)="closeWizard()">
        <span class="material-icons">close</span>
      </button>
    </div>
  
    <div class="accordion-card">
      <div class="accordion-header" (click)="toggle(0)">
        <span class="icon">
          <img src="./assets/images/intro.svg" alt="Intro" title="{{'INTRO_WIZARD_INTRO_TOOLTIP' | translate}}" />
        </span>
        <span class="title">{{'INTRO_WIZARD_INTRO_TITLE_TEXT' | translate}}</span>
        <span class="material-icons arrow"> {{ isOpen[0] ? 'expand_less' : 'expand_more' }}</span>
      </div>
      <div class="accordion-body" [class.hidden]="!isOpen[0]">
        <span [innerHtml]="configdata.IntroDetails | translate"></span>
      </div>
    </div>
  
    <div class="accordion-card">
      <div class="accordion-header" (click)="toggle(1)">
        <span class="icon">
          <img src="./assets/images/Disclaimer.svg" alt="Disclaimer" title="{{'INTRO_WIZARD_DISCLAIMER_TITLE_TEXT' | translate}}" />
        </span>
        <span class="title">{{'INTRO_WIZARD_DISCLAIMER_TITLE_TEXT' | translate}}</span>
        <span class="material-icons arrow"> {{ isOpen[1] ? 'expand_less' : 'expand_more'  }}</span>
      </div>
      <div class="accordion-body" [class.hidden]="!isOpen[1]">
        <span [innerHtml]="'INTRO_WIZARD_DISCLAIMER_CONTENT' | translate"></span>
      </div>
    </div>
  
    <div class="accordion-card">
      <div class="accordion-header" (click)="toggle(2)">
        <span class="icon">
          <img src="./assets/images/tips.svg" alt="Tips" title="{{'INTRO_WIZARD_TIPS_TITLE_TEXT' | translate}}" />
        </span>
        <span class="title">{{'INTRO_WIZARD_TIPS_TITLE_TEXT' | translate}}</span>
        <span class="material-icons arrow">{{ isOpen[2] ? 'expand_less' : 'expand_more'  }}</span>
      </div>
      <div class="accordion-body" [class.hidden]="!isOpen[2]">
        <span [innerHtml]="'INTRO_WIZARD_TIPS_CONTENT' | translate"></span>
      </div>
    </div>
  </div>
  